module.exports = __webpack_public_path__ + "38b13497d2e35f860295dbe33e35a5d3.webp";